import { connect, MapDispatchToProps, MergeProps } from "react-redux";

import { ButtonBackgroundColor, IconButton, IconButtonProps, IconColor } from "@multiweb/reactComponents";
import { createLeftClickHandler } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { createCloseButtonActivatedAction } from "../../actions";

type CloseButtonProps = {
    /** Klíč agregačního řádku */
    aggregationRowKey: string;
} & Pick<IconButtonProps, "title" | "speak">;

type DispatchProps = {
    buttonActivated: () => void;
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, CloseButtonProps> = (dispatch, { aggregationRowKey }) => ({
    buttonActivated: () => dispatch(createCloseButtonActivatedAction(aggregationRowKey)),
});

const mergeProps: MergeProps<undefined, DispatchProps, CloseButtonProps, IconButtonProps> = (
    _stateProps,
    { buttonActivated },
    { ...restOwnProps },
) => ({
    onClick: createLeftClickHandler(buttonActivated),
    iconCode: IconCode.uiCrossSmall,
    color: IconColor.textSecondary,
    backgroundColor: ButtonBackgroundColor.transparent,
    ...restOwnProps,
});

export const CloseButton = connect(undefined, mapDispatchToProps, mergeProps)(IconButton);
